import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/playerBalance.css';
import {getFormattedCurrency} from '../../../helpers/localization';

const mapStateToProps = (state, ownProps) => {
    return {
        playerLoggedIn: state.vpp.playerLoggedIn,
        systemCurrency: state.vpp.systemCurrency,
        playerBalance: state.vpp.playerBalance,
        systemLanguage: state.vpp.systemLanguage,
    };
};

const loadingAnimation = (<div className={style.loading}>
    <div>.</div>
    <div>.</div>
    <div>.</div>
</div>)

class PlayerBalance extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            playerLoggedIn: storeData.vpp.playerLoggedIn,
            systemCurrency: storeData.vpp.systemCurrency,
            playerBalance: storeData.vpp.playerBalance,
            systemLanguage: storeData.vpp.systemLanguage,
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                playerLoggedIn: storeData.vpp.playerLoggedIn,
                systemCurrency: storeData.vpp.systemCurrency,
                playerBalance: storeData.vpp.playerBalance,
                systemLanguage: storeData.vpp.systemLanguage,
            });
        }
    }

    render() {
        let amountAndCurrency = '';

        // eslint-disable-next-line no-undef
        if (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged) {
            amountAndCurrency = loadingAnimation

            if (this.state.playerBalance) {
                let convertedAmount = this.state.playerBalance
                    ? convertAmount(this.state.playerBalance.Banks.CREDIT.Amount, this.state.playerBalance.Banks.CREDIT.MinorCurrencyUnits)
                    : ''
                amountAndCurrency = (<div
                    className={style.balance}> {getFormattedCurrency(this.props.store, convertedAmount, undefined, undefined, undefined, true)} </div>)
            }
        }
        return amountAndCurrency;
    }
}

let convertAmount = (amount, minorCurrencyUnits) => {
    if (minorCurrencyUnits === 0) {
        return amount;
    }
    return amount / Math.pow(10, minorCurrencyUnits);
}

export default connect(mapStateToProps)(PlayerBalance);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/playerBalance.js